import {
  BaseAPI,
  APIError
} from './BaseAPI';
import {
  cachedObservableObject,
  cachedObservableObjectArray,
} from './Observable';

class ObservableAPI extends BaseAPI {
  
  async rawGet(path: string): Promise<object> {
    let raw;
    let url = `${this.baseUrl}${path}`;

    try {
      let fetchPromise = fetch(url, {
        credentials: 'include'  
      });

      let response = await fetchPromise;      

      raw = await response.json();
      if (response.status === 200) {
        if (raw instanceof Array) {
          return cachedObservableObjectArray(url, (objert: any) => `${url}${objert.id}/`, raw);
        }
        if ((raw instanceof Object) && (raw.id)) {
          return cachedObservableObject(url, raw);
        }
      }
    }
    catch (e) {
      console.error(e);
      throw new Error(`Error fetching ${this.path}${path} data!`);
    }

    return raw;
  }

}

export {
  ObservableAPI,
  APIError,
}